module.exports = __webpack_public_path__ + "static/media/5DPO16.6941e547.jpg";